import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-social-network-qualification.component.ajs.html';

const MODULE_NAME = 'agentBookingSocialNetworkQualification';

class AgentBookingSocialNetworkQualificationCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingSocialNetworkQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingSocialNetworkQualificationCtrl];
}

export default MODULE_NAME;
